
export default function validate(values,pass) {
    let errors = {};
    if (!values.old_password) {

      errors.old_password = 'Old Password is Required';
    } 
    // else if (!/\S+@\S+\.\S+/.test(values.email)) {
    //   errors.old_password = 'Email address is invalid';
    // }
    else if (values.old_password !== pass) {
        errors.old_password = 'Invalid Old Password';
      }
    if (!values.new_password) {

        errors.new_password = 'New Password is Required';

    }if (!values.confirm_password) {

        errors.confirm_password = 'Confirm Password is Required';
        
    }else if(values.confirm_password !== values.new_password) {

        errors.confirm_password = 'Password and Confirm Password should be same...';
    }
       
    return errors;
  };



// WEBPACK FOOTER //
// ./src/Pages/Auth/changePasswordValidation.js